/** Регулярность оплаты по тарифному плану. */
export enum CompanyPricingRegularity {
    /** Единоразово. */
    Once = "once",

    /** Ежедневно. */
    Daily = "daily",

    /** Ежемесячно. */
    Monthly = "monthly",
}
